import axios from "../../axios";

export default {
    getUserNotificationsCount() {
        return axios.get('notifications/user-notifications-count')
    },
    getUserNotifications() {
        return axios.get('notifications/user-notifications')
    },
    notificationMarkAsRead(data) {
        return axios.post('notifications/notification-mark-as-read', data)
    },
    allNotificationsMarkAsRead() {
        return axios.post('notifications/all-notifications-mark-as-read')
    },
    notificationMarkAsUnread(data) {
        return axios.post('notifications/notification-mark-as-unread', data)
    },
    notificationRemove(data) {
        return axios.post('notifications/notification-remove', data)
    },
    allNotificationsRemove() {
        return axios.post('notifications/all-notifications-remove')
    },
}